const COMMUNITIES_ROUTE_CACHE_KEY = "asasiasaCommunitiesRouteSnapshot";
const COMMUNITIES_ROUTE_CACHE_MAX_AGE = 2 * 60 * 1000;

const normalizeSnapshot = (snapshot = {}) => ({
  ownedCommunities: snapshot.ownedCommunities || [],
  archivedCommunities: snapshot.archivedCommunities || [],
  joinedCommunities: snapshot.joinedCommunities || [],
  invites: snapshot.invites || [],
  requests: snapshot.requests || [],
});

export const writeCommunitiesRouteCache = (snapshot) => {
  try {
    sessionStorage.setItem(
      COMMUNITIES_ROUTE_CACHE_KEY,
      JSON.stringify({
        cachedAt: Date.now(),
        snapshot: normalizeSnapshot(snapshot),
      }),
    );
  } catch {
    // Cache is an optimization only; navigation works without it.
  }
};

export const readCommunitiesRouteCache = () => {
  try {
    const raw = sessionStorage.getItem(COMMUNITIES_ROUTE_CACHE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed?.cachedAt || Date.now() - parsed.cachedAt > COMMUNITIES_ROUTE_CACHE_MAX_AGE) {
      sessionStorage.removeItem(COMMUNITIES_ROUTE_CACHE_KEY);
      return null;
    }

    return normalizeSnapshot(parsed.snapshot);
  } catch {
    return null;
  }
};

export const buildCommunitiesNavigationState = (returnPath = "") => {
  const snapshot = readCommunitiesRouteCache();
  if (!snapshot) return null;

  return {
    skipFullLoad: true,
    returnPath,
    ...snapshot,
  };
};

export const findCommunityInRouteCache = (communityId) => {
  const snapshot = readCommunitiesRouteCache();
  if (!snapshot || !communityId) return null;

  return (
    [
      ...snapshot.ownedCommunities,
      ...snapshot.archivedCommunities,
      ...snapshot.joinedCommunities,
    ].find((community) => String(community._id) === String(communityId)) || null
  );
};
